import { useMutationEditLead } from "@gymflow/api";
import { useQueryLead } from "libs/api/src/lib/hooks/lead/useQueryLead";
import { useTranslation } from "react-i18next";

import useGymflowModels from "../../../store";
import { Switch } from "../../atoms";

export const LeadMarketingOptionsForm = ({ leadId }: { leadId: number }) => {
  const { t } = useTranslation();
  const { api } = useGymflowModels();
  const { mutateAsync: updateUser } = useMutationEditLead({ api });
  const { data: lead } = useQueryLead({ api, leadId });
  return (
    <div className="flex w-full flex-col">
      <div className="flex w-full flex-col gap-y-2 p-6">
        <div className="flex flex-row items-center justify-between">
          <div className="flex flex-col gap-y-2">
            <div className="inline-flex text-sm font-semibold">
              {t("pages.lead.marketing.emailMarketing")}
            </div>
            <div className="inline-flex text-sm text-gray-400">
              {t("pages.lead.marketing.emailMarketingDescription")}
            </div>
          </div>
          <Switch
            value={lead?.emailCommunication ?? false}
            onChange={async (checked) => {
              await updateUser({
                id: leadId,
                patchedFields: { emailCommunication: checked },
              });
            }}
          />
        </div>
        <div className="flex flex-row items-center justify-between">
          <div className="flex flex-col gap-y-2">
            <div className="inline-flex text-sm font-semibold">
              {t("pages.lead.marketing.smsMarketing")}
            </div>
            <div className="inline-flex text-sm text-gray-400">
              {t("pages.lead.marketing.smsMarketingDescription")}
            </div>
          </div>
          <Switch
            value={lead?.smsCommunication ?? false}
            onChange={async (checked) => {
              await updateUser({
                id: leadId,
                patchedFields: { smsCommunication: checked },
              });
            }}
          />
        </div>
      </div>
    </div>
  );
};
